import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const InsightsPage = lazy(() => import("./web/InsightsPage.js").then((m) => ({ default: m.InsightsPage })));
const AlertsPage = lazy(() => import("./web/AlertsPage.js").then((m) => ({ default: m.AlertsPage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));

export default defineWebModule({ manifest, pages: { "": InsightsPage, "/alerts": AlertsPage, "/settings": SettingsPage } });
